import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import messages from './messages';
import { EXPORT_ALL, EXPORT_SELECTED } from './constants';

const ExportTypeSelector = ({ totalRecords, selectedCount, exportType, setExportType }) => {
  const chooseExportSelected = useCallback(() => {
    setExportType(EXPORT_SELECTED);
  }, [setExportType]);
  const chooseExportAll = useCallback(() => {
    setExportType(EXPORT_ALL);
  }, [setExportType]);

  return (
    <div>
      <RadioCheckList>
        <RadioCheckListItem isChecked={exportType === EXPORT_SELECTED} isDisabled={selectedCount === 0} onChecked={chooseExportSelected}>
          <FormattedMessage {...messages.exportSelectedItems} values={{ selectedCount }} />
        </RadioCheckListItem>
        <RadioCheckListItem isChecked={exportType === EXPORT_ALL} onChecked={chooseExportAll}>
          <FormattedMessage {...messages.exportAllItems} values={{ count: totalRecords }} />
        </RadioCheckListItem>
      </RadioCheckList>
    </div>
  );
};

ExportTypeSelector.propTypes = {
  totalRecords: PropTypes.number.isRequired,
  selectedCount: PropTypes.number.isRequired,
  exportType: PropTypes.oneOf([EXPORT_ALL, EXPORT_SELECTED]).isRequired,
  setExportType: PropTypes.func.isRequired,
};

export default ExportTypeSelector;
